import { PageId } from 'constants/pages'

export const enum PageIdWoofzEaster70 {
  SUBSCRIPTIONS_EASTER_70 = PageId.SUBSCRIPTIONS_EASTER_70,
  CHAT_UPSELL_EASTER_70 = PageId.CHAT_UPSELL_EASTER_70,
  UPSELL_EASTER_70 = PageId.UPSELL_EASTER_70,
  DOWNLOAD_EASTER_70 = PageId.DOWNLOAD_EASTER_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
